import { ArpMediaDraft, ArpMediaType, PaginatedResponse, PaginationParams } from '@arpeggi/shared'
import axios from 'axios'
import { useAuth } from '../../hooks/useAuth'

export interface GetDraftsParams
  extends Omit<PaginationParams<ArpMediaDraft>, 'savedTimestamps' | 'user'> {
  type?: ArpMediaType
  all?: boolean
  search?: string
  arpFormat?: 1 | 2
  name?: string
}

export interface CreateDraftDto {
  name: string
  arpFormat?: number
  arp: any
}

export interface UpdateDraftDto extends Partial<CreateDraftDto> {}

export const getSharedDraft = async (shareCode: string) => {
  const { data } = await axios.get<ArpMediaDraft>(`/api/v2/shared-drafts/${shareCode}`)

  return data
}

export const useArpDraftsAPI = () => {
  const { authenticatedGet, authenticatedPost, authenticatedPatch } = useAuth()

  /**
   * This defaults to grabbing the users drafts.
   * If the all params is passes, all drafts will be fetched.
   * Passing the all param requires a user typ to be 'admin' or 'god'
   */
  const getDrafts = async (params: GetDraftsParams) => {
    const { data } = await authenticatedGet<PaginatedResponse<ArpMediaDraft>>(
      '/api/v2/drafts',
      params
    )

    return data
  }

  const getOneDraft = async (draftId: number) => {
    const { data } = await authenticatedGet<ArpMediaDraft>(`/api/v2/drafts/${draftId}`)

    return data
  }

  const createDraft = async (dto: CreateDraftDto) => {
    const { data } = await authenticatedPost<ArpMediaDraft>('/api/v2/drafts', dto)

    return data
  }

  const updateDraft = async (id: number, dto: UpdateDraftDto) => {
    const { data } = await authenticatedPatch<ArpMediaDraft>(`/api/v2/drafts/${id}`, dto)

    return data
  }

  const getDraftShareCode = async (id: number) => {
    const { data } = await authenticatedGet<{ shareCode: string }>(
      `/api/v2/drafts/${id}/share-code`
    )

    return data
  }

  return { getDrafts, getOneDraft, createDraft, updateDraft, getDraftShareCode, getSharedDraft }
}
